import { Link } from "react-router-dom";
import { generatePath } from "react-router";
import { RouterPaths } from "../../../app/appConstants";
import React from "react";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

function PartnerApiDocsLink(props) {
    const {method} = props;
    const {getLangPath} = useLangContext();
    return <Link to={generatePath(RouterPaths.partnerApiDocs, {method})}>
        {getLangPath(`partner.api_docs.methods.${method}.title`)}
    </Link>
}

export default PartnerApiDocsLink;
